import React, { Component } from 'react';
import { notification } from 'antd';

export function showMessage(type, message, des) {
    notification[type]({
        message: message,
        description: des,
    });
};


// WEBPACK FOOTER //
// ./src/components/util/NoticeMessage.jsx